import {Icon} from '@udemy-v2/icons';
import {BlockList} from '@udemy-v2/react-core-components';
import {useI18n} from '@udemy-v2/i18n';

export interface CollapsiblePurchaseBoxContentProps {
    coursesCount: string;
    categoryName: string;
}

export function CollapsiblePurchaseBoxContent(collapsableProps: CollapsiblePurchaseBoxContentProps) {
    const {gettext, interpolate} = useI18n();
    return (
        <div>
            {collapsableProps.categoryName && (
                <BlockList.Item icon={<Icon label="" size="xsmall" glyph="video-playlist" />}>
                    <span className="ud-text-sm">
                        {interpolate(
                            gettext(
                                'Get this course and many more in %(category_name)s and access to %(courses_count)s+ courses',
                            ),
                            {
                                courses_count: collapsableProps.coursesCount,
                                category_name: collapsableProps.categoryName,
                            },
                            true,
                        )}
                    </span>
                </BlockList.Item>
            )}
            <BlockList.Item icon={<Icon label="" size="xsmall" glyph="list-alt" />}>
                <span className="ud-text-sm">
                    {gettext('AI, Development, Business, Design & 50+ topics')}
                </span>
            </BlockList.Item>
        </div>
    );
}

export const SUBSCRIPTION_SUB_VALUE_PROP_MSG =
    '<span class="bold">Our subscribers don’t pay per course.</span> ' +
    'In their first month, they take 9+ courses and save ₹4000+.';

